<template>
  <div>
    <Title :pages="[{ icon: 'circle', page: page_title.toUpperCase() }]"></Title>

    <v-container fluid>
      <Modal
        v-if="create_access"
        :modal_title="modal_title"
        :button_name="'Crear ' + modal_title"
        :formBtn="formBtn"
        :dialog="dialog"
        :parent="parent"
        :service="service"
        @updateDialog="updateDialog"
        @loadList="loadList(service)"
        :item="mainItem"
        @updateItem="
          (newItem) => {
            mainItem = newItem;
          }
        "
      />

      <v-card v-if="list_access">
        <v-card-title>
          <span class="text-uppercase">{{ page_title }}</span>
          <v-spacer></v-spacer>
          <v-text-field v-model="search" append-icon="search" label="Buscar" single-line hide-details></v-text-field>
        </v-card-title>
        <v-data-table
          :headers="headers"
          :items="list"
          :search="search"
          :loading="loading"
          loading-text="Cargando..."
          :options="{ itemsPerPage: 15 }"
          @pagination="updatePagination"
          :footer-props="{ itemsPerPageOptions: [5, 10, 15, 50, -1] }"
        >
          <template v-slot:item="props">
            <tr>
              <td>{{ props.item.name }}</td>
              <td>{{ props.item.supplier ? props.item.supplier.name : "-" }}</td>
              <td>{{ props.item.receiver ? props.item.receiver.name : "-" }}</td>
              <td>{{ props.item.cbte_tipo ? props.item.cbte_tipo.Desc : "-" }}</td>
              <td v-if="isProductCompany()">{{ stockLabel(props.item) }}</td>
              <td class="text-center">{{ props.item.items ? props.item.items.length : 0 }}</td>
              <td class="text-center">{{ props.item.tributes ? props.item.tributes.length : 0 }}</td>
              <td class="text-center px-0" style="min-width: 100px">
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="update_access" v-on="on" small color="blue" class="mr-2" @click="editItem(props.item)">edit</v-icon>
                  </template>
                  <span>Editar</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-on="on" small color="blue" class="mr-2" @click="viewItem(props.item)">remove_red_eye</v-icon>
                  </template>
                  <span>Ver</span>
                </v-tooltip>
                <v-tooltip bottom>
                  <template v-slot:activator="{ on }">
                    <v-icon v-if="delete_access" v-on="on" small color="red" class="mr-2" @click="deleteItem(props.item)">delete</v-icon>
                  </template>
                  <span>Eliminar</span>
                </v-tooltip>
              </td>
            </tr>
          </template>
          <template v-slot:no-results>
            <v-alert :value="true" color="error" icon="warning">
              {{ "Búsqueda sin resultados - " + search }}
            </v-alert>
          </template>
        </v-data-table>
      </v-card>

      <DialogDelete :dialog_delete="dialog_delete" @updateDialogDelete="updateDialogDelete" @deleteItemConfirm="deleteItemConfirm" />
    </v-container>
  </div>
</template>

<script>
import { spentTemplateService } from "@/libs/ws/spentTemplateService";
import GenericMixin from "@/mixins/GenericMixin.vue";
import RolMixin from "@/mixins/RolMixin.vue";
import SettingsMixin from "@/mixins/SettingsMixin.vue";
import Title from "@/components/Title.vue";
import DialogDelete from "@/components/DialogDelete.vue";
import Modal from "./Modal.vue";

export default {
  components: { Title, Modal, DialogDelete },
  mixins: [GenericMixin, RolMixin, SettingsMixin],
  data() {
    return {
      parent: this,
      service: spentTemplateService,
      page_title: "Plantillas de Gastos",
      modal_title: "Plantilla de Gasto",
      mainItem: {
        id: 0,
        name: "",
        supplier: null,
        receiver: null,
        warehouse: null,
        cbte_tipo: null,
        stock_spent: null,
        observation: null,
        items: [],
        tributes: [],
      },
      defaultItem: null,
      list: [],
      dialog_delete: false,
    };
  },
  computed: {
    headers() {
      const headers = [
        { text: "Nombre", align: "left", sortable: true, value: "name" },
        { text: "Proveedor", align: "left", sortable: true, value: "supplier.name" },
        { text: "Receptor", align: "left", sortable: true, value: "receiver.name" },
        { text: "Tipo de comprobante", align: "left", sortable: true, value: "cbte_tipo.Desc" },
      ];
      if (this.isProductCompany()) headers.push({ text: "Stock", align: "left", sortable: false, value: "" });
      headers.push(
        { text: "Ítems", align: "center", sortable: false, value: "" },
        { text: "Tributos", align: "center", sortable: false, value: "" },
        { text: "Acción", align: "center", value: "" }
      );
      return headers;
    },
  },
  mounted() {
    this.defaultItem = JSON.parse(JSON.stringify(this.mainItem));
    this.loadList(this.service);
  },
  methods: {
    stockLabel(item) {
      if (item.stock_spent === true) return "Con stock" + (item.warehouse ? " (" + item.warehouse.name + ")" : "");
      if (item.stock_spent === false) return "Sin stock";
      return "-";
    },
    deleteItemConfirm() {
      this.delete(this.service);
      this.dialog_delete = false;
      this.loadList(this.service);
    },
    getFilterParams() {
      return {};
    },
  },
};
</script>
